export default "/images/vendor/flag-icon-css/flags/1x1/sz.svg?468d80d14bc0084d5c0493c949230d75";